export const HEADER_BACKGROUND_BREAKPOINTS: { [key: string]: any } = {
    tablet: 660,
    desktop: 1608,
    twok: 1920,
};
